var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurplePdfDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0835 8.49297H14.6752C12.7002 8.49297 11.0918 6.88463 11.0918 4.90964V2.5013C11.0918 2.04297 10.7168 1.66797 10.2585 1.66797H6.72516C4.1585 1.66797 2.0835 3.33464 2.0835 6.30964V13.693C2.0835 16.668 4.1585 18.3346 6.72516 18.3346H13.2752C15.8418 18.3346 17.9168 16.668 17.9168 13.693V9.3263C17.9168 8.86797 17.5418 8.49297 17.0835 8.49297Z",
    fill: "#A020FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 1.84207C12.8251 1.5004 12.2334 1.73373 12.2334 2.20873V5.11707C12.2334 6.33373 13.2667 7.34207 14.5251 7.34207C15.3167 7.3504 16.4167 7.3504 17.3584 7.3504C17.8334 7.3504 18.0834 6.79207 17.7501 6.45873C16.5501 5.2504 14.4001 3.0754 13.1667 1.84207Z",
    fill: "#A020FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.457H6.25C5.90833 11.457 5.625 11.1737 5.625 10.832C5.625 10.4904 5.90833 10.207 6.25 10.207H11.25C11.5917 10.207 11.875 10.4904 11.875 10.832C11.875 11.1737 11.5917 11.457 11.25 11.457Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 14.793H6.25C5.90833 14.793 5.625 14.5096 5.625 14.168C5.625 13.8263 5.90833 13.543 6.25 13.543H9.58333C9.925 13.543 10.2083 13.8263 10.2083 14.168C10.2083 14.5096 9.925 14.793 9.58333 14.793Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplePdfDocument);
export default __webpack_public_path__ + "static/media/PurplePdfDocument.8ecf173573efa4713e2d648edd6cbea0.svg";
export { ForwardRef as ReactComponent };